import { ChevronRight } from "lucide-react";

import * as m from "@/paraglide/messages";

const STEP_STYLES = [
	{ bg: "#ffbcbe", rotate: "-1.92deg" },
	{ bg: "var(--secondary)", rotate: "3.29deg" },
	{ bg: "var(--accent)", rotate: "-3.57deg" },
	{ bg: "var(--chart-4)", rotate: "5.31deg" },
] as const;

export function WorkflowSection() {
	const steps = [
		{
			tag: m.landing_workflow_step1Tag(),
			title: m.landing_workflow_step1Title(),
			body: m.landing_workflow_step1Body(),
			...STEP_STYLES[0],
		},
		{
			tag: m.landing_workflow_step2Tag(),
			title: m.landing_workflow_step2Title(),
			body: m.landing_workflow_step2Body(),
			...STEP_STYLES[1],
		},
		{
			tag: m.landing_workflow_step3Tag(),
			title: m.landing_workflow_step3Title(),
			body: m.landing_workflow_step3Body(),
			...STEP_STYLES[2],
		},
		{
			tag: m.landing_workflow_step4Tag(),
			title: m.landing_workflow_step4Title(),
			body: m.landing_workflow_step4Body(),
			...STEP_STYLES[3],
		},
	];

	return (
		<section className="px-4 pt-24 pb-12 md:px-12 md:pt-32">
			<div className="mx-auto max-w-6xl">
				<div className="mb-12 text-center">
					<h2 className="text-balance text-4xl font-semibold leading-tight text-[#272727] md:text-5xl">
						{m.landing_workflow_heading1()}
						<br />
						<span className="font-extrabold italic text-primary">
							{m.landing_workflow_heading2()}
						</span>
					</h2>
					<p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground">
						{m.landing_workflow_subtitle()}
					</p>
				</div>

				<div className="relative">
					<div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
						{steps.map((step, i) => (
							<div
								key={step.tag}
								className="flex h-[360px] flex-col justify-between rounded-3xl p-6 shadow-[0_4px_8px_rgba(0,0,0,0.18)] transition-transform hover:rotate-0 hover:scale-[1.02]"
								style={{
									backgroundColor: step.bg,
									transform: `rotate(${step.rotate})`,
								}}
							>
								<div className="space-y-4">
									<span className="inline-flex items-center justify-center rounded-full bg-foreground/10 px-2.5 py-1 text-xs font-medium text-[#5c5c5c]">
										{i + 1}. {step.tag}
									</span>
									<h3 className="text-2xl font-semibold leading-tight text-[#272727]">
										{step.title}
									</h3>
									<p className="text-base leading-relaxed text-[#404040]">
										{step.body}
									</p>
								</div>
								<button
									type="button"
									className="inline-flex w-fit items-center gap-1 text-base font-semibold text-foreground"
								>
									{m.landing_workflow_learnMore()}
									<ChevronRight className="size-5" />
								</button>
							</div>
						))}
					</div>

					<img
						src="/images/workflow-arrow-1.svg"
						alt=""
						aria-hidden="true"
						className="pointer-events-none absolute left-1/4 top-[60%] hidden h-[110px] w-[110px] -translate-x-1/2 -translate-y-1/2 lg:block"
					/>
					<img
						src="/images/workflow-arrow-2.svg"
						alt=""
						aria-hidden="true"
						className="pointer-events-none absolute left-1/2 top-[60%] hidden h-[120px] w-[120px] -translate-x-1/2 -translate-y-1/2 lg:block"
					/>
					<img
						src="/images/workflow-arrow-3.svg"
						alt=""
						aria-hidden="true"
						className="pointer-events-none absolute left-3/4 top-[42%] hidden h-[130px] w-[130px] -translate-x-1/2 -translate-y-1/2 lg:block"
					/>
				</div>
			</div>
		</section>
	);
}
